export const serialize = function (obj) {
	var str = [];
	for (var p in obj)
		// Omit unset filters instead of sending the literal string
		// "undefined"/"null" — callers rely on `foo: x || undefined` to mean
		// "no filter", and encodeURIComponent(undefined) stringifies it.
		if (obj.hasOwnProperty(p) && obj[p] !== undefined && obj[p] !== null) {
			str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
		}
	return `?${str.join("&")}`;
}